<div class="qb-limited-period-container">
  <span class="main-label-style">{{
    "CAMPAIGN_PAGE.MILESTONE_COMPLETION_DATE_RANGE" | i18nTranslate
  }}</span>
  <div class="qb-d-flex qb-gap-20">
    <div style="width: 25%" [ngClass]="{'cursor-notallowed':status=='ACTIVE' }">
      <div [ngClass]="{'pointerevents-none':status=='ACTIVE' }">
        <span class="fs08-rem">{{
          "SHARED_PAGE.START_DATE" | i18nTranslate
        }}</span
        ><span style="color: red">*</span>
        <div
          class="formDiv-date"
          [ngClass]="{
            active:
              startDate.value == null || checkIfBeforeCurrentDate(startDate.value)
          }"
        >
          <input
            style="width: 0px; opacity: 0"
            [formControl]="startDate"
            matInput
            [matDatepicker]="pickerOffer1"
            placeholder="Choose a date"
            [min]="startDateMinValue"
            (dateChange)="startDateChange()"
            readonly
          />
          <div style="margin-left: 4px" class="formInput fs08-rem">
            {{ startDate.value | date : getDateFormat("MMM/dd/yyyy") }}
          </div>
          <mat-datepicker-toggle matSuffix [for]="pickerOffer1">
          </mat-datepicker-toggle>
          <mat-datepicker #pickerOffer1></mat-datepicker>
        </div>
      </div>
    </div>
    <div style="width: 25%">
      <span class="fs08-rem">{{ "SHARED_PAGE.END_DATE" | i18nTranslate }}</span
      ><span style="color: red">*</span>
      <div class="formDiv-date">
        <input
          style="width: 0px; opacity: 0"
          [formControl]="endDate"
          matInput
          [matDatepicker]="pickerOffer2"
          placeholder="Choose a date"
          [min]="endDateMinValue"
          (dateChange)="endDateChange()"
          readonly
        />
        <div style="margin-left: 4px" class="formInput fs08-rem">
          {{ endDate.value | date : getDateFormat("MMM/dd/yyyy") }}
        </div>
        <mat-datepicker-toggle [for]="pickerOffer2"></mat-datepicker-toggle>
        <mat-datepicker #pickerOffer2></mat-datepicker>
      </div>
    </div>
  </div>

  <!-- <span class="main-label-style">{{
    "CAMPAIGN_PAGE.MILESTONE_TIME_RANGE" | i18nTranslate
  }}</span>

  <div style="margin-top: 10px">
    <div class="qb-d-flex qb-week-class">
      <mat-slide-toggle
        color="accent"
        [(ngModel)]="everyDaySliderValue"
      ></mat-slide-toggle>
      <span class="fs08-rem">
        {{ "CAMPAIGN_PAGE.EVERY_DAY_WEEK" | i18nTranslate }}</span
      >
    </div>
    <mat-chip-list
      *ngIf="!everyDaySliderValue"
      placeholder="Select a day"
      class="font-class fs08-rem"
      multiple="true"
    >
      <mat-chip
        color="accent"
        #c="matChip"
        *ngFor="let day of weekDaysChips"
        class="font-class fs08-rem cursor-pointer weekdays-chip"
        [value]="day.name"
        (click)="toggleSelection(day)"
        [selected]="day.selected"
      >
        {{ day.name }}
      </mat-chip>
    </mat-chip-list>
  </div> -->

  <!-- <div class="qb-d-flex qb-week-class">
    <mat-slide-toggle
      color="accent"
      [(ngModel)]="anyTimeOftheDay"
      (ngModelChange)="onAnyTimeOftheDayChange($event)"
    ></mat-slide-toggle>
    <span class="fs08-rem">
      {{ "GAMIFY_PAGE.AT_ANY_TIME" | i18nTranslate }}</span
    >
  </div> -->

  <!-- <div class="qb-d-flex qb-week-class">
    <mat-slide-toggle
      color="accent"
      [(ngModel)]="specificTime"
      (ngModelChange)="onSpecificTimeChange($event)"
    ></mat-slide-toggle>
    <span class="fs08-rem">
      {{ "CAMPAIGN_PAGE.SPECIFIC_TIME" | i18nTranslate }}</span
    >
  </div> -->

  <div class="qb-d-flex qb-gap-20" *ngIf="!anyTimeOftheDay">
    <div style="width: 25%">
      <span class="fs08-rem">{{
        "SHARED_PAGE.START_TIME" | i18nTranslate
      }}</span
      ><span style="color: red">*</span>
      <div
        class="formDiv-date"
        [ngClass]="{ active: startTime.value == null }"
        style="justify-content: space-between; position: relative"
      >
        <input
          style="opacity: 0; position: absolute; cursor: pointer"
          class="formInput fs08-rem"
          [formControl]="startTime"
          [ngxTimepicker]="pickerChallenge1"
          [max]="startMaxTime"
          [min]="startMinTime"
          [format]="serviceCountry === 'US' ? 12 : 24"
          readonly
        />
        <div style="margin-left: 10px">
          {{ transformTo24HourFormat(startTime.value) | customTime }}
        </div>
        <div>
          <img
            style="margin-right: 10px; cursor: pointer"
            src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/icons/negotiator/time.svg"
            alt=""
            (closed)="startTimeChange()"
          />
          <ngx-material-timepicker
            #pickerChallenge1
            (closed)="startTimeChange()"
          >
          </ngx-material-timepicker>
        </div>
      </div>
    </div>
    <div style="width: 25%">
      <span class="fs08-rem">{{ "SHARED_PAGE.END_TIME" | i18nTranslate }}</span
      ><span style="color: red">*</span>
      <div
        class="formDiv-date"
        [ngClass]="{ active: endTime.value == null }"
        style="justify-content: space-between; position: relative"
      >
        <input
          style="opacity: 0; position: absolute; cursor: pointer"
          class="formInput"
          [formControl]="endTime"
          [ngxTimepicker]="pickerChallenge2"
          [min]="endMinTime"
          [format]="serviceCountry === 'US' ? 12 : 24"
          readonly
        />
        <div style="margin-left: 10px">
          {{ transformTo24HourFormat(endTime.value) | customTime }}
        </div>
        <div>
          <img
            style="margin-right: 10px; cursor: pointer"
            src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/icons/negotiator/time.svg"
            alt=""
            (closed)="endTimeChange()"
          />
          <ngx-material-timepicker #pickerChallenge2 (closed)="endTimeChange()">
          </ngx-material-timepicker>
        </div>
      </div>
    </div>
  </div>
</div>
